let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("2byDt")).then(() => parcelRequire('840FM'));